$(function () {

  const mobileBreakpoint = 1240;

  // Tabs
  GLOBAL.tabs = '.js-tabs';
  $(document.body).on('click', GLOBAL.tabs + ' .tabs-nav a', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('active')) {
      $(this).addClass('active').closest('li').siblings().find('a').removeClass('active');
      const newTab = $($(this).attr('href'), $(this).parents(GLOBAL.tabs));
      const oldTab = newTab.siblings('.active');
      moveBanners(oldTab, newTab);
      newTab.addClass('active').siblings().removeClass('active');
    }
  })

  // Togglers
  .on('click', '.js-toggler', function (e) {
    e.preventDefault();

    // For news comments stream and footer banners in desktop footer only
    if ($(this).hasClass('footer-minify')) {
      if (!$(this).hasClass('minified')) {
        $(this).addClass('minified');
        $(this).parent().next().hide();
        $('#footer-banners').addClass('minified');
        $('.footer-bottom').addClass('minified');
      } else {
        $(this).removeClass('minified');
        $(this).parent().next().show();
        $('#footer-banners').removeClass('minified');
        $('.footer-bottom').removeClass('minified');
      }
      return;
    }

    if (!$(this).hasClass('opened')) {
      $(this).addClass('opened').next().show('fast');
    } else {
      $(this).removeClass('opened').next().hide('fast');
    }
  });

  // Sliders
  function initSliders(container) {
    if (GLOBAL.windowSize[0] <= mobileBreakpoint) {
      // Disable news scrollable containers
      $('.js-scrollable', container).each(function () {
        var $swiper = $(this).find('.swiper');
        if ($swiper.data('initialized')) {
          $swiper.get(0).swiper.disable();
        }
      });

      // Disable sliders
      $('.js-slider', container).each(function () {
        if ($(this).data('initialized')) {
          $(this).find('.swiper').get(0).swiper.disable();
        }
      });
    } else {
      // Enable news scrollable containers
      $('.js-scrollable').each(function () {
        var $swiper = $(this).find('.swiper'),
            $scrollbar = $(this).find('.swiper-scrollbar');

        if ($swiper.data('initialized')) {
          $swiper.get(0).swiper.enable();
        } else {
          $swiper.data('initialized', true);
          var newsScrollable = new Swiper($swiper.get(0), {
            direction: 'vertical',
            freeMode: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            preloadImages: false,
            resistanceRatio: 0,
            slidesPerView: 'auto',
            scrollbar: {
              el: $scrollbar.get(0),
              draggable: true
            },
            mousewheel: {
              sensitivity: .3
            },
            on: {
              setTranslate: function (swiper, translate) {
                $(swiper.wrapperEl).data('currentTranslate', translate);
              },
              observerUpdate: function (swiper) {
                // Обновляем свайпер после загрузки внешних ресурсов баннера, требуется observeSlideChildren
                $('img', swiper.wrapperEl).each((key, item) => {
                  item.addEventListener('load', () => {
                    swiper.update();
                  }, false);
                });
                swiper.setTranslate($(swiper.wrapperEl).data('currentTranslate'));
              }
            }
          });
        }
      });

      // Enable sliders
      $('.js-slider', container).each(function () {
        var $self = $(this);

        if ($(this).data('initialized')) {
          $(this).find('.swiper').get(0).swiper.enable();
        } else {
          $(this).data('initialized', true);
          var slider = new Swiper($(this).find('.swiper').get(0), {
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            preloadImages: false,
            simulateTouch: false,
            slidesPerView: 1,
            navigation: {
              prevEl: $self.find('.swiper-button-prev').get(0),
              nextEl: $self.find('.swiper-button-next').get(0)
            }
          });
        }
      });
    }
  }


  // Responsive
  GLOBAL.actualResizer = 'throttledresize' in jQuery.event.special ? 'throttledresize' : 'resize';
  function responsiveFixes() {
    var ww = $(window)[0].innerWidth || $(window).width(),
        wh = $(window)[0].innerHeight || $(window).height();

    GLOBAL.windowSize = [ww, wh];

    // Set --vh custom property to correct window height calculation for mobile browsers
    var vh = wh * .01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // Prevent fixes if changed only window height
    GLOBAL.onlyWindowHeightChanged = false;
    if ($(document.body).data('originalWW') && $(document.body).data('originalWW') == ww) {
      GLOBAL.onlyWindowHeightChanged = true;
      return;
    }
    $(document.body).data('originalWW', ww);

    // Responsive menu
    $('.mobile-menu-link, .submenu .button-close, #mobile-menu-overlay').off('.ht');
    $('.mobile-menu-link, .submenu .button-close').on('click.ht', function (e) {
      e.preventDefault();
      if (GLOBAL.windowSize[0] > mobileBreakpoint) {
        var es = !$(document.body).hasClass('submenu-opened') ? 300 : 0;
        $.overlayLoader(!$(document.body).hasClass('submenu-opened'), {
          effectSpeed: es,
          fixedElements: '.footer-fixed'
        });
      }
      $(document.body).toggleClass('submenu-opened');
    });
    $('#mobile-menu-overlay').on('click.ht', function () {
      $(document.body).removeClass('submenu-opened');
      if (GLOBAL.windowSize[0] > mobileBreakpoint) {
        $.overlayLoader(false, {
          effectSpeed: 0,
          fixedElements: '.footer-fixed'
        });
      }
    });

    // Responsive manipulations
    autoMove();

    if (ww <= 768) {

      $('.pa-options').insertBefore($('.pa-image'));

    } else {

      $('.form-place-ad .row-2 .col:first-child').append($('.pa-options'));

    }

    // Responsive actions
    initSliders(document);

    if (ww <= mobileBreakpoint) {

      // Enable news inner image caption toggler
      $('.news-inner-info').on('click', function () {
        var $self = $(this),
            $caption = $(this).next('.news-inner-caption');
        if ($caption.is(':hidden')) {
          $(this).addClass('hidden');
          $caption.removeClass('hidden');
          $(this).parent().find('.news-item-reactions').addClass('hidden');
          $(this).parent().find('.ya-share2').addClass('hidden');
          setTimeout(function () {
            $self.removeClass('hidden');
            $caption.addClass('hidden');
            $self.parent().find('.news-item-reactions').removeClass('hidden');
            $self.parent().find('.ya-share2').removeClass('hidden');
          }, 5000);
        }
      });

      // Close all modal windows
      if ($('#uniloader-overlay').is(':visible')) {
        $.overlayLoader(false, {
          effectSpeed: 0
        });
      }

    } else {

      // Disable news inner image caption toggler
      $('.news-inner-info').off('click');

    }

    if (ww <= 768) {

    } else {

      // Cabinet user profile must be always visible
      $('.cabinet-user-more').removeClass('opened');
      $('.cabinet-user-content').removeAttr('style');

    }

    // Open all the first tabs once for desktop and once for mobiles
    $(GLOBAL.tabs).each(function () {
      if (!$(this).data('initialized') || ($(this).data('initialized') <= mobileBreakpoint && ww > mobileBreakpoint) || ($(this).data('initialized') > mobileBreakpoint && ww <= mobileBreakpoint)) {
        const defaultActiveTabLink = $(this).data('initialized', ww).find('.tabs-nav li.default-active');
        if (defaultActiveTabLink.length && defaultActiveTabLink.is(':visible')) {
          $('a', defaultActiveTabLink).trigger('click');
        } else {
          $(this).data('initialized', ww).find('.tabs-nav li:first-child a').trigger('click');
        }
      }
    });
  }

  // Перемещение элементов в зависимости от устройства
  function autoMove() {
    const [ww, wh] = GLOBAL.windowSize;
    const elements = {};
    $('.js-automove').each(function () {
      const container = $(this);
      const group = container.data('group');
      if (!(group in elements)) {
        elements[group] = {};
      }
      elements[group][container.data('target')] = container;
    });
    for (const group in elements) {
      if (elements.hasOwnProperty(group)) {
        const content = [elements[group]?.mobile?.contents(), elements[group]?.desktop?.contents()];
        if (ww <= mobileBreakpoint) {
          elements[group]?.mobile?.append(content);
        } else {
          elements[group]?.desktop?.append(content);
        }
      }
    }
  }

  // Перенос баннеров между вкладками
  function moveBanners(oldTab, newTab) {
    if (oldTab.length) {
      const oldBanners = $('.js-movable-banner', oldTab);
      const newBanners = $('.js-movable-banner', newTab);
      oldBanners.each((oldBannerIndex, oldBanner) => {
        const newBanner = newBanners.filter(`[data-index=${oldBanner.dataset.index}]`);
        newBanner.append($(oldBanner).contents());
      });
    }
  }
  
  // Баннер в футере может быть разной высоты
  // Т.к. баннеры не адаптивны - responsiveFixes() тут не нужен
  const fb = 'footer-banners';
  const fbObserver = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      const $img = $('#' + fb + ' .all-b:visible img');
      if ($img.length) {
        $img.on('load', function () {
          document.documentElement.style.setProperty('--hbh', $img.width() / $img.height());
        });
      }
    }
  });
  if ($('#' + fb).length) {
    fbObserver.observe(document.getElementById(fb), {
      subtree: true,
      childList: true
    });
  }

  responsiveFixes();
  $(window).on('load ' + GLOBAL.actualResizer, responsiveFixes);


  // Selects
  $('body:not(.affiche-list-page) .js-select, .affiche-list-page .modal-affiche-add .js-select').select2({
    dropdownCssClass: 'hide-search'
  });
  $('.magazines-list-item-page .js-select').select2({
    selectionCssClass: 'select2-no-border',
    dropdownCssClass: 'select2-no-border hide-search'
  });
  $('.affiche-list-page main .js-select:not(#places)').select2({
    selectionCssClass: 'select2-no-border select2-affiche',
    dropdownCssClass: 'select2-no-border select2-affiche hide-search'
  });
  // Поиск и выбор места
  const affichePlaceSelector = $('.affiche-list-page #places');
  affichePlaceSelector.select2({
    selectionCssClass: 'select2-no-border select2-affiche',
    dropdownCssClass: 'select2-no-border select2-affiche',
    ajax: {
      delay: 100,
      url: '/api/affiche/places',
      dataType: 'json',
      cache: true,
      processResults: function (data) {
        data.results.unshift({
          id: 0,
          text: 'Все площадки',
        });
        return data;
      },
    },
    minimumInputLength: 2,
    templateResult: function (state) {
      return state.address ? $('<span>' + state.text + '</span><span>' + state.address + '</span>') : state.text;
    }
  }).on('select2:opening', function(e) {
    $(this).data('select2').$dropdown.find('input[type=search]')
      .attr('placeholder', 'Начните вводить название или адрес');
  });

  $('.js-select').on('change', function () {
    var $select2 = $(this).next('.select2');
    $select2.find('.select2-selection').removeClass('placeholder-not-selected');
    if ($select2.find('.select2-selection__rendered').text() != $(this).find('option:first').text()) {
      $select2.find('.select2-selection').addClass('placeholder-not-selected');
    }
  }).trigger('change');

  // Селекты для навигации
  $('.js-select-change-location').on('change', function () {
    const url = $(this).val();
    if (url && url != document.location.href) {
      document.location.href = url;
    }
  });
  affichePlaceSelector.on('change', function () {
    const urlPlaceholder = affichePlaceSelector.data('location-placeholder');
    const placeId = affichePlaceSelector.val();
    const url = urlPlaceholder.replace(/place=placeholder/gi, placeId > 0 ? `place=${encodeURIComponent(placeId)}` : '').replace(/&$/gi, '');
    if (url && url != document.location.href) {
      document.location.href = url;
    }
  });

  // Sorting selects
  $('.js-sorting-content select').on('change', function () {
    const $self = $(this),
          value = $self.val(),
          $links = $self.parent().find('a');

    $links.removeClass('active').addClass('hidden-768').each(function () {
      if ($(this).text() == $self.find(':selected').text()) {
        $(this).removeClass('hidden-768').addClass('active');
      }
    });

    if (value.startsWith('http')) {
      document.location.href = value;
    }

  });

  // Calendar
  $.datepicker.setDefaults($.datepicker.regional['ru']);
  const calendarContainer = $('.news-items-calendar');
  calendarContainer.datepicker({
    minDate: calendarContainer.data('min-date'),
    maxDate: calendarContainer.data('max-date'),
    defaultDate: calendarContainer.data('default-date'),
    dateFormat: calendarContainer.data('date-format'),
    // Выбор даты
    onSelect: function (date, picker) {
      document.location.href = calendarContainer.data('location').replace(/date=placeholder/gi, `date=${encodeURIComponent(date)}`);
    },
    // Выделение дней с событиями
    onUpdateDatepicker: function (picker) {
      const cacheKey = `affiche.schedule:${picker.selectedYear}:${picker.selectedMonth}`;
      const updatePicker = function (schedule) {
        $(`td[data-month=${picker.selectedMonth}][data-year=${picker.selectedYear}]`, picker.dpDiv).each(function () {
          const cell = $(this);
          const date = $('a[data-date]', this).data('date') - 1;
          if (!schedule[date]) {
            cell.addClass('ui-datepicker-unselectable ui-state-disabled');
          }
        });
      };
      if (cacheKey in sessionStorage) {
        try {
          updatePicker(JSON.parse(sessionStorage.getItem(cacheKey)));
        } catch (error) {
          console.error(error);
        };
      } else {
        $.get(`/api/affiche/schedule?year=${picker.selectedYear}&month=${picker.selectedMonth + 1}`)
          .done(function (data, status, xhr) {
            if (data instanceof Array) {
              try {
                sessionStorage.setItem(cacheKey, JSON.stringify(data));
                updatePicker(data);
              } catch (error) {
                console.error(error);
              };
            }
          })
          .fail(function (xhr, status, error) {
            console.error(error);
          });
      }
    }
  });

  // Passwords
  $('.input-password-toggler').on('click', function (e) {
    e.preventDefault();
    var self = this;
    $(this).toggleClass('shown').attr('title', ($(this).hasClass('shown') ? 'Скрыть' : 'Показать') + ' пароль').parent().find('.input')[0].setAttribute('type', $(self).hasClass('shown') ? 'text' : 'password');
  });


  // Scroll handlers
  function scrollHandlers() {
    var scrollTop = $(window).scrollTop();

    // Toggle button-top
    if (scrollTop > $('#content').offset().top) {
      $('.button-top').addClass('shown');
    } else {
      $('.button-top').removeClass('shown');
    }

    // Fix some elements
    var $ni = $('.nav-important'),
        $cm = $('.cabinet-menu'),
        $cl = $('.cabinet-left');
    $ni.removeClass('fixed');
    $cm.removeClass('fixed');
    $cl.removeClass('fixed');
    $(document.body).removeAttr('style');

    if ($ni.length && GLOBAL.windowSize[0] <= mobileBreakpoint && scrollTop >= $ni.offset().top - $('header').height()) {
      $ni.addClass('fixed');
      if ($cm.length && $cl.length) {
        $('body:not(.error-page)').css('padding-top', parseFloat($(document.body).css('padding-top')) + parseFloat($ni.height()) + parseFloat($cm.height()) + parseFloat($cl.find('.cabinet-user').outerHeight()));
        $cm.addClass('fixed');
        $cl.addClass('fixed');
      } else {
        $('body:not(.error-page)').css('padding-top', parseFloat($(document.body).css('padding-top')) + parseFloat($ni.height()));
      }
    }
  }

  scrollHandlers();
  $(window).on('load scroll ' + GLOBAL.actualResizer, scrollHandlers);
  if (GLOBAL.isTouchscreen) {
    $(document).on('touchmove pointermove', scrollHandlers);
  }


  // Fullscreen
  GLOBAL.fullscreen = {
    isSupported: function () {
      if ('fullscreenEnabled' in document) {
        return document.fullscreenEnabled;
      } else if ('msFullscreenEnabled' in document) {
        return document.msFullscreenEnabled;
      } else if ('mozFullscreenEnabled' in document) {
        return document.mozFullscreenEnabled;
      } else if ('webkitFullscreenEnabled' in document) {
        return document.webkitFullscreenEnabled;
      }
      return false;
    },

    isFullscreen: function () {
      return document.fullscreenElement || document.msFullscreenElement || document.mozFullscreenElement || document.webkitFullscreenElement;
    },

    request: function (node) {
      if (node.requestFullscreen) {
        node.requestFullscreen(); // edge doesn't return promise
      } else if (node.msRequestFullscreen) {
        node.msRequestFullscreen(); // edge doesn't return promise
      } else if (node.mozRequestFullScreen) {
        node.mozRequestFullScreen(); // edge doesn't return promise
      } else if (node.webkitRequestFullscreen) {
        node.webkitRequestFullscreen(); // edge doesn't return promise
      }
    },

    exit: function () {
      if ('exitFullscreen' in document) {
        document.exitFullscreen(); // edge doesn't return promise
      } else if ('msExitFullscreen' in document) {
        document.msExitFullscreen(); // edge doesn't return promise
      } else if ('mozExitFullscreen' in document) {
        document.mozExitFullscreen(); // edge doesn't return promise
      } else if ('webkitExitFullscreen' in document) {
        document.webkitExitFullscreen(); // edge doesn't return promise
      }
    },

    onFullscreenChange: function (callback) {
      if ('fullscreenEnabled' in document) {
        document.addEventListener('fullscreenchange', callback);
      } else if ('msFullscreenEnabled' in document) {
        document.addEventListener('msfullscreenchange', callback);
      } else if ('mozFullscreenEnabled' in document) {
        document.addEventListener('mozfullscreenchange', callback);
      } else if ('webkitFullscreenEnabled' in document) {
        document.addEventListener('webkitfullscreenchange', callback);
      }
    }
  };

  var $fsButtons = $('.modal-fullscreen');
  if (GLOBAL.fullscreen.isSupported()) {
    $fsButtons.each(function () {
      var $button = $(this),
          $target = $(this).parents('.modal');
      $button.on('click', function () {
        if (GLOBAL.fullscreen.isFullscreen()) {
          GLOBAL.fullscreen.exit();
        } else {
          GLOBAL.fullscreen.request($target.get(0));
        }
      });

      GLOBAL.fullscreen.onFullscreenChange(function (e) {
        if (GLOBAL.fullscreen.isFullscreen()) {
          $target.addClass('is-fullscreen');
        } else {
          $target.removeClass('is-fullscreen');
        }
      });
    });
  } else {
    $fsButtons.hide();
  }


  // EditorJS templates

  // template-image-slider
  $('.template-image-slider').each(function () {
    var $sliderMain = $(this).find('.swiper-main'),
        $sliderThumbs = $(this).find('.swiper-thumbs'),
        $caption = $(this).find('.template-image-slider-caption'),
        setCaption = function (swiper) {
          $caption.text($(swiper.slides[swiper.activeIndex]).attr('title') || '');
        },
        sliderThumbs = new Swiper($sliderThumbs.get(0), {
          preloadImages: false,
          slidesPerView: 5,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          watchSlidesProgress: true
        }),
        sliderMain = new Swiper($sliderMain.get(0), {
          spaceBetween: 10,
          autoHeight: true,
          thumbs: {
            swiper: sliderThumbs,
            autoScrollOffset: 1
          },
          navigation: {
            prevEl: $sliderMain.find('.swiper-button-prev').get(0),
            nextEl: $sliderMain.find('.swiper-button-next').get(0)
          },
          on: {
            afterInit: function (s) {
              setCaption(s);
            },
            slideChange: function (s) {
              setCaption(s);
            }
          }
        });
  });

  // Было/стало для контента новостей
  $('.js-comparison-news').each(function () {
    $(this).find('.template-image-ba-images').twentytwenty({
      no_overlay: true,
      click_to_move: true
    });
  });


  // Place an ad
  var paForm = '.form-place-ad';

  function paCalculate() {
    var $text = $('.pa-textarea textarea', paForm),
        $phone = $('.pa-phone', paForm);

    var basePrice = $('.pa-rubrics :selected', paForm).data('price'),
        typePrice = $('.form-option :checked', paForm).data('price'),
        discont = $('.pa-duration :selected', paForm).data('price'),
        publications = $('.pa-duration :selected', paForm).val(),
        textSymbols = $.trim($text.val()).length,
        phoneSymbols = $.trim($phone.val()).length,
        priceBase = 0,
        price = 0;

    if (phoneSymbols > 0) {
      // 5 символов для " Тел."
      textSymbols += phoneSymbols + 5;
    }
    // @see placeAd in Ads.php
    priceBase = Math.round(parseFloat(basePrice) * parseFloat(typePrice) * parseFloat(discont) * publications);
    price = Math.round(Math.ceil(textSymbols / 20) * priceBase);

    $('.pa-price span', paForm).text(price);
    $('.pa-base-price span', paForm).text(priceBase);
    $('.pa-symbols span', paForm).text(textSymbols);
    $('.pa-symbols-left span', paForm).text(20 - textSymbols % 20);
    if (price > 0 && phoneSymbols > 0) {
      $('.button', paForm).removeAttr('disabled');
    } else {
      $('.button', paForm).attr('disabled', 'disabled');
    }
  }

  $('.pa-rubrics, .pa-duration, .pa-options input', paForm).on('change', function () {
    paCalculate();
  }).trigger('change');
  $('.pa-phone, .pa-textarea textarea', paForm).on('input', function () {
    paCalculate();
  });
  $('.pa-rubrics', paForm).on('change', function () {
    $('.pa-warnings > div:visible', paForm).addClass('hidden');
    $('#pa-warning-' + $(this).val(), paForm).removeClass('hidden');
  }).trigger('change');
  $('.pa-options input', paForm).on('change', function () {
    $('.pa-image', paForm).find('img').attr('src', $(this).data('image'));
  });
  $('.pa-options input:checked', paForm).trigger('change');


  // Cabinet authors
  $('.cabinet-author').on('click', function () {
    if (GLOBAL.isTouchscreen && !$(this).hasClass('touched')) {
      $('.cabinet-authors .cabinet-author').removeClass('touched');
      $(this).addClass('touched');
    }
  });
  $('.cabinet-author-close').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (GLOBAL.isTouchscreen && $(this).parent().hasClass('touched')) {
      $(this).parent().removeClass('touched');
    }
  });

  // Cabinet settings
  $('.cabinet-settings-tags .cabinet-settings-action-add').on('click', function (e) {
    e.preventDefault();
    $('<span>\
      <a href="news-list.htm">' + $(this).prev().find(':selected').text() + '</a>\
      <a href="#" class="cabinet-settings-action cabinet-settings-action-remove" title="Прекратить отслеживание новостей с этим тегом"></a>\
    </span>').appendTo($(this).parents('.news-item-tags').prev());
  });
  $(document.body).on('click', '.cabinet-settings-tags .cabinet-settings-action-remove', function (e) {
    e.preventDefault();
    if (confirm('Вы уверены, что хотите прекратить отслеживание новостей с тегом "' + $(this).prev().text() + '"?')) {
      $(this).parent().remove();
    }
  });

  $('.cabinet-settings-notifications .cabinet-settings-action-add').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $item = $(this).parent().parent().clone();
    $item.find('.cabinet-settings-action').removeClass('cabinet-settings-action-add').addClass('cabinet-settings-action-remove').attr('title', 'Удалить эту временную точку');
    $(this).parent().parent().after($item);
  });
  $(document.body).on('click', '.cabinet-settings-notifications .cabinet-settings-action-remove', function (e) {
    e.preventDefault();
    $(this).parent().parent().remove();
  });


  // POST links
  $(document.body).on('click', 'a[post]', function (e) {
    e.preventDefault();
    var link = $(this)
      , form = $('<form>')
      , token = $('meta[name="csrf-token"]')
      ;
    link.after(form);
    form
      .attr('method', 'post')
      .attr('action', link.attr('post'))
      .css('display', 'none')
      .append('<input type="hidden" name="_token" value="' + token.attr('content') + '" />')
      .submit()
      ;
  });

  // Лента настроения
  $('.news-inner-moods').each(function () {
    const block = $(this);
    const total = block.prev('.news-inner-rating').find('span');
    const id = block.data('id');
    const idClass = block.data('class');
    const variants = $('[class^=news-inner-moods-]', block);
    let oldCookieValue = `n${id}`;
    let localStorageKey = `e:n${id}`;
    let apiEndpoint = `/api/news/${id}/emotion`;
    if (idClass == 'affiche.event') {
      oldCookieValue = `ae${id}`;
      localStorageKey = `e:ae${id}`;
      apiEndpoint = `/api/affiche/events/${id}/emotion`;
    }
    const updateRating = function (emotions, selected) {
      total.text(emotions.total);
      variants.each(function () {
        const variant = $(this);
        const value = emotions[variant.data('emotion') + '_percent'];
        variant.css('width', value + '%');
        const a = variant.find('a');
        if (variant.data('emotion') == selected) {
          a.addClass('active');
        } else {
          a.removeClass('active');
        }
        a.text(value + '%');
      });
    };
    let isVoteAvailable = true;
    $.each(GLOBAL.getCookie('emotion_poll')?.split(';'), function (key, value) {
      if (value == oldCookieValue) {
        // Оценка недоступна, выбранная ранее оценка неизвестна
        isVoteAvailable = false;
      }
    });
    // Выделяем выбранный вариант, т.к. иначе не всегда можно понять, какую реакцию поставил пользователь (в случае большого числа оценок)
    variants.filter(`[data-emotion=${localStorage.getItem(localStorageKey)}]`).find('a').addClass('active');
    variants.on('click', function (e) {
      e.preventDefault();
      const variant = $(this);
      if (isVoteAvailable) {
        const request = {'_token': $('meta[name="csrf-token"]').attr('content'), 'emotion': variant.data('emotion')};
        // Ранее выбранная эмоция для замены
        request.replace = localStorage.getItem(localStorageKey);
        if (request.emotion != request.replace) {
          $.post(apiEndpoint, request)
            .done(function (data, status, xhr) {
              if ('emotions' in data) {
                localStorage.setItem(localStorageKey, request.emotion);
                updateRating(data.emotions, request.emotion);
              }
            })
            .fail(function (xhr, status, error) {
              alert(error);
            })
            ;
        }
      } else {
        alert('Вы уже голосовали за эту новость!');
      }
    });
  });

  // На мобилках в этих компонентах дублируются баннеры из NewsOtd
  // Баннеры adfox не будут показываться в скрытом контейнере: https://yandex.ru/support/adfox-sites/sites/get-code.html#get-code__container-requirements
  // Создаём плейсхолдеры и переносим баннеры при переключении вкладок
  function prepareTabsBannersPlaceholders(sourceTab, targetTab) {
    const banners = $('.js-movable-banner', sourceTab);
    targetTab.find('.swiper-slide:has(> .news-item)').each((slideIndex, slide) => {
      banners.each((bannerIndex, banner) => {
        if (slideIndex === banner.dataset.index - 1) {
          $(slide).after($(`<div class="all-b vertical-b-container js-movable-banner" data-index="${banner.dataset.index}"></div>`));
        }
      });
    });
  }

  // Вкладки больше не содержат асинхронных компонентов, баннеры определяются в новостях дня
  const TulaNewsTab = $('#news-items-tabs-all');
  const NewsOtdTab = $('#news-items-tabs-main');
  const RnWTab = $('#news-items-tabs-around');
  prepareTabsBannersPlaceholders(NewsOtdTab, TulaNewsTab);
  prepareTabsBannersPlaceholders(NewsOtdTab, RnWTab);
  // Вкладка, открытая по умолчанию
  moveBanners(NewsOtdTab, TulaNewsTab);

  // Подгружаемые компоненты шаблона
  // @todo Имеет смысл перенести на https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements
  async function processAsyncComponents(container) {
    const components = $('async-component', container);
    for (var i = 0, l = components.length; i < l; i++) {
      // Последовательная загрузка компонентов используется для снижения нагрузки на сервер
      await (async function (component) {
        const holder = $(component);
        const componentName = holder.attr('name');
        const promise = new Promise((resolve, reject) => {
          $.get('/api/async-component', {name:componentName, params:holder.text()})
            .done(async function (data, status, xhr) {
              const replacement = $(data);
              holder.replaceWith(replacement);
              initSliders(replacement);
              await processAsyncComponents(replacement);
              processBanners(replacement);
              resolve();
            })
            .fail(function (xhr, status, error) {
              console.error(error);
              reject();
            })
            ;
        });
        await promise;
      })(components[i]);
    }
  }
  processAsyncComponents(document);

  // Баннеры
  function processBanners(container) {
    $('template[banner]', container).each(function () {
      const template = $(this);
      const holder = template.parent();
      const mobileOnly = template.attr('mobile') !== undefined;
      const desktopOnly = template.attr('desktop') !== undefined;
      let applyTemplate = true;
      if (mobileOnly) {
        applyTemplate = GLOBAL.windowSize[0] <= mobileBreakpoint;
      }
      if (desktopOnly) {
        applyTemplate = GLOBAL.windowSize[0] > mobileBreakpoint;
      }
      if (applyTemplate) {
        const banner = $(`<div class="js-banner-${template.attr('banner')}">${template.html()}</div>`);
        switch (template.attr('banner')) {
          case 'news-content': {
            // Баннер после 3-го абзаца в тексте новости/записи
            const thirdP = holder.find('> p:not(:empty)').eq(2);
            if (thirdP.length) {
              banner.addClass('all-b inner-b');
              thirdP.after(banner);
            }
            break;
          }
          case 'news-feed':
            // Не должен показываться на страницах новостей, если есть "Возле партнёрских новостей" (news-partners), т.к. это баннер одного рекламодателя
            // Инициализация происходит асинхронно, поэтому варианты обработки могут быть разными
            template.replaceWith(banner);
            if ($('.js-banner-news-partners').length) {
              banner.hide();
            }
            break;
          case 'news-partners':
            // На страницах новостей должен скрывать "Внутри ленты новостей" (news-feed), т.к. это баннер одного рекламодателя
            // Инициализация происходит асинхронно, поэтому варианты обработки могут быть разными
            template.replaceWith(banner);
            $('.js-banner-news-feed').hide();
            break;
          default:
            template.replaceWith(banner);
        }
      }
    });
  }
  processBanners(document);

  // Показать ещё (комментарии/новости пользователя)
  $('.js-load-more').on('click', function (e) {
    e.preventDefault();
    const link = $(this);
    const containerClass = link.data('container');
    const linkText = link.text();
    const linkHref = link.attr('href');
    if (linkHref) {
      link.text('...');
      link.attr('href', '');
      $.get(linkHref)
        .done(function (data, status, xhr) {
          const dom = $(`<div>${data}</div>`);
          const append = dom.find(`.${containerClass}`).children();
          const newLink = dom.find('.js-load-more');
          $(`.${containerClass}`).append(append);
          $.scrollTo(append);
          if (newLink.length > 0) {
            link.text(linkText);
            link.attr('href', newLink.attr('href'));
          }
        })
        .fail(function (xhr, status, error) {
          console.error(error);
          link.text(linkText);
          link.attr('href', linkHref);
        })
        ;
    }
  });

  // Опросы
  // С голосованием отдельно за каждый вариант
  $('form.js-poll-single').each(function () {
    const form = $(this);
    const variants = $('[data-variant]', this);
    variants.each(function () {
      const variant = $(this);
      const link = variant.find('a');
      const votesTotal = variant.find('.js-votes-total');
      const votesPercent = variant.find('.js-votes-percent');
      link.on('click', function (e) {
        e.preventDefault();
        const request = {'_token': $('meta[name="csrf-token"]').attr('content'), 'variant': variant.data('variant')};
        $.post(form.attr('action'), request)
          .done(function (data, status, xhr) {
            if (data.success) {
              if (data.votesLeft <= 0) {
                // Скрываем остальные варианты, если больше голосовать нельзя
                variants.filter(function () {
                  return $(this).data('variant') != variant.data('variant');
                }).find('a').replaceWith('');
              }
              link.replaceWith('Голос учтён');
              if (data.votesTotal) {
                votesTotal.text(data.votesTotal);
              }
              if (data.votesPercent) {
                votesPercent.css('width', data.votesPercent + '%');
              }
            } else {
              alert('Не удалось проголосовать, попробуйте позже.');
            }
          })
          .fail(function (xhr, status, error) {
            alert(xhr.responseJSON?.message || error);
          })
          ;
      });
    });
  });
  // С голосованием сразу за все варианты
  $('form.js-poll-bulk').each(function () {
    const form = $(this);
    const limit = form.data('limit');
    const variants = $('input[type=checkbox]', this);
    // Лимиты вариантов
    variants.on('change', function (e) {
      if (variants.filter(':checked').length >= limit) {
        variants.filter(':not(:checked)').prop('disabled', true);
      } else {
        variants.filter(':not(:checked)').prop('disabled', false);
      }
    }).trigger('change');
    // Голосование
    form.on('submit', function (e) {
      e.preventDefault();
      $.post(form.attr('action'), form.serializeArray())
        .done(function (data, status, xhr) {
          if (data.success) {
            form.replaceWith(data.form);
          } else {
            alert('Не удалось проголосовать, попробуйте позже.');
          }
        })
        .fail(function (xhr, status, error) {
          alert(xhr.responseJSON?.message || error);
        })
        ;
    });
  });

});